
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1547',
  depVersions: {
  "customer-portal-app": "static-1.1547",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.443",
  "data-fetching-client": "static-1.9401",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24531",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5315",
  "hs-test-utils": "static-1.7709",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9289",
  "hubspot-dlb": "static-2.1786",
  "hubspot-prosemirror": "static-1.17412",
  "hubspot-url-utils": "static-1.3873",
  "HubStyleTokens": "static-2.11147",
  "I18n": "static-7.1551",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6180",
  "payment-link-components": "static-1.22744",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6613",
  "quartz-core": "static-1.5832",
  "react": "static-7.176",
  "react-colorpicker": "static-2.9936",
  "react-dlb": "static-1.70",
  "react-utils": "static-2.5106",
  "rich-text-lib": "static-1.19337",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17487",
  "ui-components-test-utils": "static-1.5285",
  "UIComponents": "static-3.8094",
  "foundations-assets": "static-1.4556",
  "foundations-components": "static-1.7369",
  "foundations-theming": "static-1.4129",
  "foundations-theming-specialty": "static-1.1845",
  "framer-motion": "static-1.66",
  "history": "static-4.47",
  "metrics-js": "static-1.9346",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.453",
  "quartz-config": "static-1.391",
  "quartz-routing": "static-1.43",
  "quick-fetch": "static-1.3660",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16357",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7864",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.49",
  "ui-addon-draggable": "static-3.4469",
  "ui-addon-react-router-dom": "static-1.9271",
  "usage-tracker": "static-1.7058",
  "usage-tracker-anonymous": "static-1.5475",
  "usage-tracker-core": "static-1.6908",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3157",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2890",
  "quartz-webpack": "static-1.2837",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "commerce-analytics-service-client": "static-1.3414",
  "customer-data-objects": "static-1.7341",
  "frontend-preferences-client": "static-1.7649",
  "laboratory-lib": "static-3.6868",
  "onboarding-scopes": "static-1.6168",
  "rpc-client-utils": "static-1.4332",
  "ui-addon-opt": "static-4.8112",
  "HeadJS": "static-2.697",
  "hs-test-utils-bend-plugin": "static-1.2820",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3835",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7346",
  "cssUtils": "static-1.710",
  "customer-data-ui-utilities": "static-1.9549",
  "HubStyle": "static-2.11455",
  "knowledge-content-types": "static-1.8290",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.288",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.482",
  "ui-addon-emoji-picker": "static-1.9614",
  "ui-addon-i18n": "static-1.10853",
  "ui-business-units-lib": "static-1.8746",
  "ui-shepherd-react": "static-3.9868",
  "video-components-external": "static-1.10346",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4056",
  "commerce-tours-lib": "static-1.5609",
  "customer-data-properties": "static-1.50569",
  "getting-started-shared-tasks": "static-1.17694",
  "growth-onboarding-reliability": "static-1.4813",
  "onboarding-tours": "static-1.16166",
  "reference-resolvers-lite": "static-1.7815",
  "sales-checkout-service-client": "static-1.3426",
  "ui-addon-iframeable": "static-1.8745",
  "user-context": "static-1.4819",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.778",
  "hubspotter-http": "static-1.4409",
  "icons": "static-2.616",
  "mobile-manifest-mixins": "static-1.470",
  "quartz-auth": "static-1.288",
  "quartz-head": "static-1.278",
  "quartz-test": "static-1.288",
  "usage-tracker-container": "static-1.7048",
  "ui-fonts": "static-1.409",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9151",
  "data-token-picker": "static-1.15934",
  "FileManagerLib": "static-1.38324",
  "property-translator": "static-1.5138",
  "atom": "static-1.4795",
  "merchandise-lib": "static-1.255",
  "purchase-motions-components": "static-1.5363",
  "salesImages": "static-1.519",
  "self-service-api": "static-1.9953",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4232",
  "foundations-components-test-utils": "static-1.4852",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1071",
  "bend-plugin-foundations-components": "static-1.3638",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "trellis-assets": "static-1.1010",
  "bend-plugin-foundations-theming": "static-1.2612",
  "foundations-theming-base": "static-1.3114",
  "stylex": "static-1.26",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4199",
  "react-flip-move": "static-1.64",
  "bender-build-tools": "static-1.2853",
  "inbound-db-properties-service-client": "static-1.3609",
  "superstore": "static-1.4497",
  "feedback-loader": "static-1.28726",
  "ai-components-ui-library": "static-1.8166",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27764",
  "sassPrefix": "static-1.150",
  "react-dnd-compat": "static-1.4348",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2191",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7885",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4373",
  "content-media-composition-data-lib": "static-1.11208",
  "content-media-compositions": "static-2.15215",
  "idb-keyval": "static-1.38",
  "immer": "static-1.33",
  "immerable": "static-1.3879",
  "magpie-lib": "static-1.5300",
  "magpie-types": "static-1.4760",
  "media-bridge-lib": "static-1.18456",
  "video-data-lib": "static-1.34004",
  "commerce-products-lib": "static-1.8640",
  "crm-message-bus": "static-1.42151",
  "growth-data-modal": "static-1.5058",
  "hubspot-apollo-client": "static-1.4604",
  "onboarding-tours-client": "static-1.4380",
  "calling-global-api": "static-1.63438",
  "calling-internal-common": "static-1.31014",
  "calling-lifecycle-internal": "static-1.64820",
  "calling-lifecycle-messages": "static-1.57114",
  "conditional-properties-service-client": "static-1.3554",
  "crm-links": "static-1.5976",
  "customer-data-objects-ui-components": "static-1.12727",
  "customer-data-property-utils": "static-1.7796",
  "external-options-client-types": "static-1.3914",
  "file-manager-components": "static-1.22684",
  "framework-data-schema-resolvers": "static-1.6592",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.387",
  "inbound-db-meta-service-client": "static-1.3391",
  "inbounddb-objects-service-types": "static-1.3981",
  "meetings-icalendar-utils-lib": "static-1.358",
  "multi-currency-client-types": "static-1.3449",
  "object-builder-ui-client": "static-1.47751",
  "pipeline-validation-client-types": "static-1.3718",
  "property-value-citations": "static-1.1183",
  "pulse": "static-1.220",
  "smart-property-lib": "static-1.5651",
  "tiered-pricing": "static-1.718",
  "ui-addon-form-validation": "static-1.10719",
  "growth-onboarding-confetti": "static-1.2776",
  "growth-onboarding-next-action-utils": "static-1.1219",
  "navigation-components": "static-1.17057",
  "onboarding-tours-utils": "static-1.232",
  "ui-shepherd-tracker": "static-1.7249",
  "ui-universal-auth": "static-1.8600",
  "batch-promise": "static-1.1254",
  "navigation-messaging": "static-1.6384",
  "getting-started-shared-tasks-store": "static-1.16812",
  "hubspotter-http-shared-msw-handlers": "static-1.9287",
  "audio-components": "static-1.5510",
  "FileManagerCore": "static-1.38183",
  "FileManagerImages": "static-1.35835",
  "video-components": "static-1.12349",
  "growth-monetization-service-types": "static-1.4248",
  "nav-client-types": "static-1.2056",
  "purchase-motions-api": "static-1.5366",
  "signup-constants": "static-1.18254",
  "signup-ui-url-generator": "static-2.7760",
  "trials-service-types": "static-1.3649",
  "chatspot-core": "static-1.20065",
  "chirp-fetch": "static-1.1606",
  "ContentUtils": "static-1.67427",
  "copilot-toolkit": "static-1.10355",
  "growth-onboarding-feedback-components": "static-1.6310",
  "hls.js": "static-1.33",
  "reactive-lib": "static-1.450",
  "simple-logging-lib": "static-1.2775",
  "customer-data-tracking": "static-1.6586",
  "products-iframe-lib": "static-1.7145",
  "products-ui-components-shared-msw-handlers": "static-1.9671",
  "hubspot-apollo-cache": "static-1.63",
  "calling-error-reporting": "static-1.31020",
  "shared-worker-versioning": "static-1.10742",
  "calling-usage-tracker": "static-1.6262",
  "calling-orchestration-shared-library": "static-1.34588",
  "voice-sms-access-library": "static-1.36",
  "conversations-skeleton-state": "static-1.6974",
  "location-customization-utils-lib": "static-1.8343",
  "crm-pipelines-api-client-types": "static-1.3895",
  "framework-builder-read-service-client": "static-1.3778",
  "framework-data-schema-quick-fetch": "static-1.6497",
  "persist-promise": "static-1.3411",
  "directed-graph": "static-1.660",
  "event-emitter": "static-1.650",
  "breeze-intelligence-kit": "static-1.5216",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9372",
  "fsm": "static-1.3456",
  "policy-lib": "static-1.6525",
  "react-tinymce": "static-1.54440",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9435",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53566",
  "tinymce-plugins": "static-1.56680",
  "tinymce-themes": "static-1.55536",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4257",
  "video-embed": "static-1.34838",
  "content-icons-ui": "static-1.2130",
  "social-insights-client-types": "static-1.21145",
  "eligibility-engine-service-types": "static-1.2930",
  "chatspot-client-types": "static-1.10385",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4531",
  "integrations-lib": "static-1.15198",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4018",
  "calling-orchestration-schema": "static-1.34813",
  "crm-record-cards-service-types": "static-1.3382",
  "highcharts": "static-8.98",
  "trellis-story-utils": "static-1.4246",
  "storybook-react": "static-1.27",
  "hub-http-contrib": "static-1.2769",
  "interframe": "static-3.4516",
  "tinymce-data": "static-1.39651",
  "ui-addon-sales-email": "static-1.4937",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11907",
  "layout-dnd-utils": "static-1.10882",
  "react-codemirror": "static-1.10330",
  "ui-brand-identity-lib": "static-1.13529",
  "NamespacedHubStyle": "static-2.8829",
  "outpost": "static-1.3936",
  "flux-actions": "static-1.300",
  "integrations-error-boundary-lib": "static-1.12613",
  "integrations-tracking-lib": "static-1.5308",
  "native-integrations-shared-strings": "static-1.7513",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10097",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67502",
  "layout-data-lib": "static-1.9207",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2721",
  "advanced-menus-core": "static-1.14697",
  "advanced-menus-lib": "static-1.11686",
  "ExportDialog": "static-6.10111",
  "ui-memberships-settings-lib": "static-1.33238",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14696",
  "simple-menus-lib": "static-1.16213"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1547",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.443",
  "data-fetching-client": "/data-fetching-client/static-1.9401",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24531",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5315",
  "hs-test-utils": "/hs-test-utils/static-1.7709",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9289",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17412",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyleTokens": "/HubStyleTokens/static-2.11147",
  "I18n": "/I18n/static-7.1551",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6180",
  "payment-link-components": "/payment-link-components/static-1.22744",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6613",
  "quartz-core": "/quartz-core/static-1.5832",
  "react": "/react/static-7.176",
  "react-colorpicker": "/react-colorpicker/static-2.9936",
  "react-dlb": "/react-dlb/static-1.70",
  "react-utils": "/react-utils/static-2.5106",
  "rich-text-lib": "/rich-text-lib/static-1.19337",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17487",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5285",
  "UIComponents": "/UIComponents/static-3.8094",
  "foundations-assets": "/foundations-assets/static-1.4556",
  "foundations-components": "/foundations-components/static-1.7369",
  "foundations-theming": "/foundations-theming/static-1.4129",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1845",
  "framer-motion": "/framer-motion/static-1.66",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9346",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.453",
  "quartz-config": "/quartz-config/static-1.391",
  "quartz-routing": "/quartz-routing/static-1.43",
  "quick-fetch": "/quick-fetch/static-1.3660",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16357",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7864",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.49",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4469",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9271",
  "usage-tracker": "/usage-tracker/static-1.7058",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5475",
  "usage-tracker-core": "/usage-tracker-core/static-1.6908",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3157",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2890",
  "quartz-webpack": "/quartz-webpack/static-1.2837",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3414",
  "customer-data-objects": "/customer-data-objects/static-1.7341",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7649",
  "laboratory-lib": "/laboratory-lib/static-3.6868",
  "onboarding-scopes": "/onboarding-scopes/static-1.6168",
  "rpc-client-utils": "/rpc-client-utils/static-1.4332",
  "ui-addon-opt": "/ui-addon-opt/static-4.8112",
  "HeadJS": "/HeadJS/static-2.697",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2820",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3835",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7346",
  "cssUtils": "/cssUtils/static-1.710",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9549",
  "HubStyle": "/HubStyle/static-2.11455",
  "knowledge-content-types": "/knowledge-content-types/static-1.8290",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.288",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9614",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10853",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8746",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9868",
  "video-components-external": "/video-components-external/static-1.10346",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4056",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5609",
  "customer-data-properties": "/customer-data-properties/static-1.50569",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17694",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4813",
  "onboarding-tours": "/onboarding-tours/static-1.16166",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7815",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3426",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8745",
  "user-context": "/user-context/static-1.4819",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.778",
  "hubspotter-http": "/hubspotter-http/static-1.4409",
  "icons": "/icons/static-2.616",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.470",
  "quartz-auth": "/quartz-auth/static-1.288",
  "quartz-head": "/quartz-head/static-1.278",
  "quartz-test": "/quartz-test/static-1.288",
  "usage-tracker-container": "/usage-tracker-container/static-1.7048",
  "ui-fonts": "/ui-fonts/static-1.409",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9151",
  "data-token-picker": "/data-token-picker/static-1.15934",
  "FileManagerLib": "/FileManagerLib/static-1.38324",
  "property-translator": "/property-translator/static-1.5138",
  "atom": "/atom/static-1.4795",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "purchase-motions-components": "/purchase-motions-components/static-1.5363",
  "salesImages": "/salesImages/static-1.519",
  "self-service-api": "/self-service-api/static-1.9953",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4232",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4852",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1071",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3638",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "trellis-assets": "/trellis-assets/static-1.1010",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2612",
  "foundations-theming-base": "/foundations-theming-base/static-1.3114",
  "stylex": "/stylex/static-1.26",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4199",
  "react-flip-move": "/react-flip-move/static-1.64",
  "bender-build-tools": "/bender-build-tools/static-1.2853",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3609",
  "superstore": "/superstore/static-1.4497",
  "feedback-loader": "/feedback-loader/static-1.28726",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8166",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27764",
  "sassPrefix": "/sassPrefix/static-1.150",
  "react-dnd-compat": "/react-dnd-compat/static-1.4348",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2191",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7885",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4373",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11208",
  "content-media-compositions": "/content-media-compositions/static-2.15215",
  "idb-keyval": "/idb-keyval/static-1.38",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3879",
  "magpie-lib": "/magpie-lib/static-1.5300",
  "magpie-types": "/magpie-types/static-1.4760",
  "media-bridge-lib": "/media-bridge-lib/static-1.18456",
  "video-data-lib": "/video-data-lib/static-1.34004",
  "commerce-products-lib": "/commerce-products-lib/static-1.8640",
  "crm-message-bus": "/crm-message-bus/static-1.42151",
  "growth-data-modal": "/growth-data-modal/static-1.5058",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4604",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4380",
  "calling-global-api": "/calling-global-api/static-1.63438",
  "calling-internal-common": "/calling-internal-common/static-1.31014",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64820",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57114",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3554",
  "crm-links": "/crm-links/static-1.5976",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12727",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7796",
  "external-options-client-types": "/external-options-client-types/static-1.3914",
  "file-manager-components": "/file-manager-components/static-1.22684",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6592",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.387",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3391",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3981",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.358",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3449",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47751",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3718",
  "property-value-citations": "/property-value-citations/static-1.1183",
  "pulse": "/pulse/static-1.220",
  "smart-property-lib": "/smart-property-lib/static-1.5651",
  "tiered-pricing": "/tiered-pricing/static-1.718",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10719",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2776",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1219",
  "navigation-components": "/navigation-components/static-1.17057",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.232",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7249",
  "ui-universal-auth": "/ui-universal-auth/static-1.8600",
  "batch-promise": "/batch-promise/static-1.1254",
  "navigation-messaging": "/navigation-messaging/static-1.6384",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16812",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9287",
  "audio-components": "/audio-components/static-1.5510",
  "FileManagerCore": "/FileManagerCore/static-1.38183",
  "FileManagerImages": "/FileManagerImages/static-1.35835",
  "video-components": "/video-components/static-1.12349",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4248",
  "nav-client-types": "/nav-client-types/static-1.2056",
  "purchase-motions-api": "/purchase-motions-api/static-1.5366",
  "signup-constants": "/signup-constants/static-1.18254",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7760",
  "trials-service-types": "/trials-service-types/static-1.3649",
  "chatspot-core": "/chatspot-core/static-1.20065",
  "chirp-fetch": "/chirp-fetch/static-1.1606",
  "ContentUtils": "/ContentUtils/static-1.67427",
  "copilot-toolkit": "/copilot-toolkit/static-1.10355",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6310",
  "hls.js": "/hls.js/static-1.33",
  "reactive-lib": "/reactive-lib/static-1.450",
  "simple-logging-lib": "/simple-logging-lib/static-1.2775",
  "customer-data-tracking": "/customer-data-tracking/static-1.6586",
  "products-iframe-lib": "/products-iframe-lib/static-1.7145",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9671",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31020",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10742",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6262",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34588",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.36",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6974",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8343",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3895",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3778",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6497",
  "persist-promise": "/persist-promise/static-1.3411",
  "directed-graph": "/directed-graph/static-1.660",
  "event-emitter": "/event-emitter/static-1.650",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5216",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9372",
  "fsm": "/fsm/static-1.3456",
  "policy-lib": "/policy-lib/static-1.6525",
  "react-tinymce": "/react-tinymce/static-1.54440",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9435",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53566",
  "tinymce-plugins": "/tinymce-plugins/static-1.56680",
  "tinymce-themes": "/tinymce-themes/static-1.55536",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4257",
  "video-embed": "/video-embed/static-1.34838",
  "content-icons-ui": "/content-icons-ui/static-1.2130",
  "social-insights-client-types": "/social-insights-client-types/static-1.21145",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2930",
  "chatspot-client-types": "/chatspot-client-types/static-1.10385",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4531",
  "integrations-lib": "/integrations-lib/static-1.15198",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4018",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34813",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3382",
  "highcharts": "/highcharts/static-8.98",
  "trellis-story-utils": "/trellis-story-utils/static-1.4246",
  "storybook-react": "/storybook-react/static-1.27",
  "hub-http-contrib": "/hub-http-contrib/static-1.2769",
  "interframe": "/interframe/static-3.4516",
  "tinymce-data": "/tinymce-data/static-1.39651",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4937",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11907",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10882",
  "react-codemirror": "/react-codemirror/static-1.10330",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13529",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8829",
  "outpost": "/outpost/static-1.3936",
  "flux-actions": "/flux-actions/static-1.300",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12613",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5308",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7513",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10097",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67502",
  "layout-data-lib": "/layout-data-lib/static-1.9207",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2721",
  "advanced-menus-core": "/advanced-menus-core/static-1.14697",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11686",
  "ExportDialog": "/ExportDialog/static-6.10111",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33238",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14696",
  "simple-menus-lib": "/simple-menus-lib/static-1.16213"
}
};
